module.exports = __webpack_public_path__ + "Icono_Instituciones-Bco_512px.png";